// Copyright (c) 2025 by Audere

import { Controller, useFormContext } from "react-hook-form";
import { MenuItem, Select, TextField } from "@mui/material";

import React from "react";
import { debounceForDataChange } from "../utils/taskUtils";

interface AdditionalInputFieldProps {
  name: string;
  inputType: "dropdown" | "text";
  possibleResponses?: string[];
  onChangeEvent: () => void;
}

const AdditionalInputField: React.FC<AdditionalInputFieldProps> = ({
  name,
  inputType,
  possibleResponses,
  onChangeEvent,
}) => {
  const { control } = useFormContext();

  if (inputType === "dropdown") {
    return (
      <Controller
        name={name}
        control={control}
        defaultValue=""
        render={({ field }) => (
          <Select
            {...field}
            onChange={(event) => {
              field.onChange(event.target.value);
              onChangeEvent();
            }}
            fullWidth
          >
            {possibleResponses?.map((resp) => (
              <MenuItem key={resp} value={resp}>
                {resp}
              </MenuItem>
            ))}
          </Select>
        )}
      />
    );
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <TextField
          {...field}
          onBlur={() => {
            field.onBlur();
            onChangeEvent();
          }}
          onChange={(e) => {
            field.onChange(e);
            debounceForDataChange(onChangeEvent);
          }}
          multiline
          fullWidth
        />
      )}
    />
  );
};

export default React.memo(AdditionalInputField);
